import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import ProductCard from "../components/ProductCard";

const LOOKBOOK_IMAGE = "https://customer-assets.emergentagent.com/job_speedway-drops/artifacts/6i9pdeal_IMG_3889.jpeg";

const BUILD_PHOTOS = [
  { src: "https://customer-assets.emergentagent.com/job_speedway-drops/artifacts/2toa5v6n_IMG_3884.jpeg", car: "C7 Z06 + R8 V10 Drag Builds" },
  { src: "https://customer-assets.emergentagent.com/job_speedway-drops/artifacts/akm9mp5j_IMG_3886.jpeg", car: "Lamborghini Huracán · 3.72 @ 196 mph" },
  { src: "https://customer-assets.emergentagent.com/job_speedway-drops/artifacts/uoxreug5_IMG_3888.jpeg", car: "Chevrolet Camaro Z/28" },
];

const FINISHES = [
  { id: "signature_chrome", name: "Signature Chrome", price_per_wheel: 2749, blurb: "Full mirror-polished chrome. Timeless. Bold. Flawless.", popular: true },
  { id: "race_chrome",      name: "Race Chrome",      price_per_wheel: 2749, blurb: "Chrome face and lip with black hardware for a motorsport look." },
  { id: "midnight_rose",    name: "Midnight Rose",    price_per_wheel: 2874, blurb: "Satin black barrel with rose gold face and hardware. Pure attitude." },
  { id: "rose_gold_pvd",    name: "Rose Gold PVD",    price_per_wheel: 2999, blurb: "Full rose gold PVD finish. Premium. Exclusive. Unmistakable." },
];

const SPEC_ICONS = [
  { k: "6061-T6", v: "Forged Aluminum" },
  { k: "3-Piece", v: "Construction" },
  { k: "True Beadlock", v: "Rear Options" },
  { k: "Custom", v: "Offsets" },
  { k: "Custom", v: "Backspacing" },
  { k: "Custom Bolt", v: "Patterns" },
  { k: "Made", v: "In USA" },
  { k: "Lifetime", v: "Structural Warranty" },
];

export default function Wheels() {
  const [singleWheels, setSingleWheels] = useState([]);

  useEffect(() => {
    api.get("/products?category=wheels").then((r) => setSingleWheels(r.data));
  }, []);

  return (
    <div className="bg-ink text-white min-h-screen pb-24" data-testid="wheels-page">
      {/* HERO */}
      <section className="pt-28 pb-12 border-b border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-mono text-[11px] uppercase tracking-[0.4em] text-adrenaline">Lone Star Speed Signature Mesh Series</div>
          <h1 className="text-display text-6xl md:text-8xl lg:text-9xl uppercase leading-[0.9] mt-3">
            Built For Speed.<br /><span className="text-adrenaline">Made To Win.</span>
          </h1>
          <p className="text-zinc-400 text-lg max-w-2xl mt-5">
            One design. Four finishes. 3-piece forged. Buy wheel-by-wheel or as a full set. Every wheel engineered from 6061-T6 forged aluminum and built to your exact fitment.
          </p>
          <div className="flex flex-wrap gap-3 mt-7">
            <span className="text-mono text-[11px] uppercase tracking-[0.3em] border border-adrenaline text-adrenaline px-4 py-2">3-Piece Forged</span>
            <span className="text-mono text-[11px] uppercase tracking-[0.3em] border border-adrenaline text-adrenaline px-4 py-2">Fitment Verified</span>
            <span className="text-mono text-[11px] uppercase tracking-[0.3em] border border-adrenaline text-adrenaline px-4 py-2">Built To Win</span>
          </div>
          <div className="mt-8 flex items-baseline gap-4 flex-wrap">
            <div>
              <div className="text-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">Starting At</div>
              <div className="text-display text-5xl text-adrenaline">$2,749</div>
              <div className="text-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">Per Wheel · From $10,996 / Set Of 4</div>
            </div>
            <Link
              to="/mesh-series"
              data-testid="wheels-build-cta"
              className="bg-adrenaline text-black text-mono text-xs uppercase tracking-[0.3em] px-8 py-4 hover:bg-adrenaline/90 transition-colors inline-block"
            >
              Build Your Set →
            </Link>
          </div>
        </div>
      </section>

      {/* BRAND LOOKBOOK */}
      <section className="py-2 bg-black" data-testid="wheels-lookbook">
        <div className="max-w-6xl mx-auto px-4">
          <img src={LOOKBOOK_IMAGE} alt="Lone Star Speed Signature Mesh Series — Built for Speed. Made to Win." className="w-full h-auto block" loading="lazy" />
        </div>
      </section>

      {/* SPEC ROW */}
      <section className="py-16 border-y border-white/5 bg-carbon" data-testid="wheels-specs">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4">
            {SPEC_ICONS.map((s) => (
              <div key={s.v} className="text-center border border-white/5 bg-ink px-3 py-5">
                <div className="text-display text-xl text-adrenaline leading-tight">{s.k}</div>
                <div className="text-mono text-[9px] uppercase tracking-[0.3em] text-zinc-400 mt-1">{s.v}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ONE DESIGN. FOUR FINISHES. */}
      <section className="py-20" data-testid="wheels-finishes">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-16">
            <div className="section-divider w-32 mx-auto mb-6" />
            <h2 className="text-display text-4xl md:text-6xl uppercase">One Design. <span className="text-adrenaline">Four Finishes.</span></h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-1">
            {FINISHES.map((f) => (
              <Link
                key={f.id}
                to="/mesh-series"
                data-testid={`finish-card-${f.id}`}
                className="bg-carbon border border-white/5 hover:border-adrenaline/60 p-8 flex flex-col gap-4 transition-colors group relative"
              >
                {f.popular && (
                  <span className="absolute top-0 left-0 bg-adrenaline text-black text-mono text-[10px] uppercase tracking-[0.3em] px-3 py-1">
                    Most Popular
                  </span>
                )}
                <div className="aspect-square bg-ink flex items-center justify-center text-mono text-[10px] uppercase tracking-[0.3em] text-zinc-600 border border-white/5">
                  {f.name}
                </div>
                <div>
                  <div className="text-heading uppercase text-xl tracking-wider">{f.name}</div>
                  <p className="text-zinc-400 text-sm mt-2 leading-relaxed">{f.blurb}</p>
                </div>
                <div className="mt-auto pt-4 border-t border-white/5">
                  <div className="text-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">Starting At</div>
                  <div className="text-display text-2xl text-adrenaline">${f.price_per_wheel.toLocaleString()}</div>
                  <div className="text-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">Per Wheel · ${(f.price_per_wheel * 4).toLocaleString()} / Set</div>
                  <div className="text-mono text-[11px] uppercase tracking-[0.3em] text-adrenaline mt-4 group-hover:translate-x-1 transition-transform">View Details →</div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* DETAILS THAT MATTER */}
      <section className="py-20 border-t border-white/5" data-testid="wheels-builds">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12">
            <div className="text-mono text-[11px] uppercase tracking-[0.4em] text-adrenaline">Built On</div>
            <h2 className="text-display text-4xl md:text-6xl uppercase mt-2">Real Builds. Real Drivers.</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-1">
            {BUILD_PHOTOS.map((p) => (
              <div key={p.src} className="aspect-[4/3] relative overflow-hidden bg-black group">
                <img src={p.src} alt={p.car} className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-700" loading="lazy" />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 via-black/60 to-transparent p-5">
                  <div className="text-mono text-[10px] uppercase tracking-[0.3em] text-adrenaline">Lone Star Speed Build</div>
                  <div className="text-heading uppercase text-sm mt-1">{p.car}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SINGLE WHEEL REPLACEMENTS */}
      {singleWheels.length > 0 && (
        <section className="py-20 border-t border-white/5" data-testid="wheels-singles">
          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
              <div>
                <div className="text-mono text-[11px] uppercase tracking-[0.4em] text-adrenaline">Replacements & Single Wheels</div>
                <h2 className="text-display text-4xl md:text-5xl uppercase mt-2">Sold Individually</h2>
                <p className="text-zinc-400 text-sm mt-3 max-w-xl">For replacements, custom one-off builds, or single-wheel show pieces. Need a full set? Use the Build Your Set flow above for fitment-verified custom orders.</p>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-1">
              {singleWheels.map((p) => <ProductCard key={p.id} product={p} />)}
            </div>
          </div>
        </section>
      )}

      {/* BOTTOM CTA */}
      <section className="py-20 border-t border-white/5 text-center" data-testid="wheels-bottom-cta">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <div className="text-mono text-[11px] uppercase tracking-[0.4em] text-adrenaline">Custom Built. Fitment Verified.</div>
          <h2 className="text-display text-4xl md:text-6xl uppercase leading-none mt-3">Engineered To Win.</h2>
          <p className="text-zinc-400 mt-5">Every set is built specifically for your vehicle. We verify fitment before production so your wheels are engineered to fit, perform, and look right.</p>
          <Link
            to="/mesh-series"
            data-testid="wheels-bottom-build-cta"
            className="mt-8 inline-block bg-adrenaline text-black text-mono text-xs uppercase tracking-[0.3em] px-10 py-5 hover:bg-adrenaline/90 transition-colors"
          >
            Build Your Set →
          </Link>
        </div>
      </section>
    </div>
  );
}
